/* Bourgeois jerky buy box · built by Ariel Creative Group
 * Loaded only on the cajun-jerky template.
 *
 * Prices and subscription plans are read from Shopify at render time via
 * [data-jky-plan-data] (see snippets/jerky-plan-data.liquid). Nothing here
 * hard-codes a price. The frequency radios live inside the product form
 * (snippets/product-form.liquid) so `selling_plan` is submitted with the
 * variant id. This file fills in prices and decorates the pack tiles.
 *
 * 2026-08-10 · v4, for the two option product (Buy as × Pack Size).
 *
 *   Per row walking. Querying ".variant-input" globally returned all seven
 *   buttons across both option rows: the grid was told there were seven
 *   columns and BEST RATE landed on "1/2 lb. packs". A row counts as the size
 *   row if any of its values parse as an N-Pack or match LEGACY_WEIGHTS;
 *   otherwise it is the mode row and gets no weights, prices or flags. Rows are
 *   tagged data-jky-row so the stylesheet can treat them differently.
 *
 *   Visible column counts. Impulse marks unreachable option values .disabled
 *   and leaves them on the page; the stylesheet hides them, so the count is
 *   taken from visible tiles and recomputed on every change.
 *
 *   Add to cart shows the LINE total. It used to print the unit price, so a
 *   quantity of three read "ADD TO CART · $25.49" while the cart charged
 *   $76.47. The stepper buttons call stepUp/stepDown, which do not fire a
 *   change event, so the clicks are listened for directly.
 *
 *   Subscriptions are bundles only. Appstle's plan is attached at product
 *   level, so every variant inherits it, including the two individual sizes.
 *   Rather than fight that here, the frequency block is hidden in Individual
 *   mode and the one-time radio is forced, so no selling_plan can be posted
 *   from this page. That is presentation, not enforcement: detaching those two
 *   variants in Appstle is what actually stops a subscription being created
 *   through another surface.
 */
(function () {
  "use strict";

  var LEGACY_WEIGHTS = {
    "1/4 lb. packs": "4 oz vacuum sealed",
    "1/2 lb. packs": "8 oz vacuum sealed"
  };

  var data = null;

  function money(cents) {
    if (cents === null || cents === undefined || cents === "" || isNaN(cents)) return "";
    return "$" + (Number(cents) / 100).toFixed(2);
  }

  function readData() {
    var el = document.querySelector("[data-jky-plan-data]");
    if (!el) return null;
    try { return JSON.parse(el.textContent); }
    catch (e) { if (window.console) console.warn("[jky] plan data did not parse", e); return null; }
  }

  function form() { return document.querySelector('form[action*="/cart/add"]'); }

  function currentVariantId() {
    var f = form();
    var sel = f && f.querySelector('[name="id"]');
    if (sel && sel.value) return String(sel.value);
    if (data) { for (var k in data.variants) { if (data.variants[k].available) return k; } }
    return null;
  }

  function currentVariant() {
    var id = currentVariantId();
    return id && data && data.variants[id] ? data.variants[id] : null;
  }

  function variantByOptionValue(value) {
    if (!data || !value) return null;
    for (var id in data.variants) {
      var t = String(data.variants[id].title);
      if (t === value) return { id: id, v: data.variants[id] };
      var parts = t.split(" / ");
      for (var i = 0; i < parts.length; i++) {
        if (parts[i] === value) return { id: id, v: data.variants[id] };
      }
    }
    return null;
  }

  function packCount(title) {
    var m = /^\s*(\d+)\s*-?\s*pack\s*$/i.exec(title || "");
    return m ? parseInt(m[1], 10) : null;
  }

  function poundLabel(lbs) {
    var whole = Math.floor(lbs + 1e-9);
    var rem = Math.round((lbs - whole) * 100) / 100;
    var frac = rem === 0.25 ? "1/4" : rem === 0.5 ? "1/2" : rem === 0.75 ? "3/4" : "";
    if (whole === 0) return frac ? frac + " lb" : lbs + " lbs";
    if (!frac) return whole + (whole === 1 ? " lb" : " lbs");
    return whole + " " + frac + " lbs";
  }

  function weightLine(title) {
    var n = packCount(title);
    if (!n) return LEGACY_WEIGHTS[title] || "";
    return poundLabel(n / 4);
  }

  function isSizeValue(v) { return packCount(v) !== null || !!LEGACY_WEIGHTS[v]; }

  function rows() { return document.querySelectorAll('.variant-wrapper[data-type="button"]'); }

  function qtyValue() {
    var q = document.querySelector(".jky-qty__input");
    var n = q ? parseInt(q.value, 10) : 1;
    return (!n || isNaN(n) || n < 1) ? 1 : n;
  }

  /* Which value of the "Buy as" row is selected. "" if there is no mode row. */
  function currentMode() {
    var row = document.querySelector('.variant-wrapper[data-jky-row="mode"]');
    if (!row) return "";
    var tiles = row.querySelectorAll(".variant-input");
    for (var i = 0; i < tiles.length; i++) {
      var input = tiles[i].querySelector("input[data-variant-input]");
      if (input && input.checked) return tiles[i].getAttribute("data-value") || "";
    }
    return "";
  }

  /* ---------------------------------------------------------------- tiles */

  function addFlag(tile, text, cls) {
    if (!tile || tile.querySelector(".jky-tile-flag")) return;
    var flag = document.createElement("span");
    flag.className = "jky-tile-flag " + cls;
    flag.textContent = text;
    tile.appendChild(flag);
  }

  function syncTileCount() {
    var rs = rows();
    for (var r = 0; r < rs.length; r++) {
      var wrap = rs[r].querySelector(".variant-input-wrap");
      var tiles = rs[r].querySelectorAll(".variant-input");
      var visible = 0;
      for (var i = 0; i < tiles.length; i++) {
        var lab = tiles[i].querySelector(".variant__button-label");
        if (lab && lab.classList.contains("disabled")) continue;
        visible++;
      }
      if (wrap) wrap.style.setProperty("--jky-tile-count", visible || tiles.length);
    }
  }

  function decorateTiles() {
    var rs = rows();
    for (var r = 0; r < rs.length; r++) {
      var row = rs[r];
      var tiles = row.querySelectorAll(".variant-input");
      if (!tiles.length) continue;

      var sizeTiles = [], packTiles = [];
      for (var i = 0; i < tiles.length; i++) {
        var v = tiles[i].getAttribute("data-value");
        if (isSizeValue(v)) sizeTiles.push(tiles[i]);
        if (packCount(v) !== null) packTiles.push(tiles[i]);
      }
      row.setAttribute("data-jky-row", sizeTiles.length ? "size" : "mode");

      for (var j = 0; j < sizeTiles.length; j++) {
        var el = sizeTiles[j];
        if (el.getAttribute("data-jky-done")) continue;
        var title = el.getAttribute("data-value");
        var label = el.querySelector(".variant__button-label");
        if (!label) continue;

        var wt = weightLine(title);
        if (wt) {
          var wtEl = document.createElement("span");
          wtEl.className = "jky-tile-wt";
          wtEl.textContent = wt;
          label.appendChild(wtEl);
        }

        var n = packCount(title);
        var hit = variantByOptionValue(title);
        if (hit && n) {
          var perEl = document.createElement("span");
          perEl.className = "jky-tile-per";
          perEl.setAttribute("data-jky-tile-per", hit.id);
          perEl.textContent = money(hit.v.price / n) + " per pack";
          label.appendChild(perEl);
        }
        el.setAttribute("data-jky-done", "1");
      }

      if (packTiles.length >= 3 && !row.getAttribute("data-jky-flagged")) {
        addFlag(packTiles[Math.floor((packTiles.length - 1) / 2)], "Most Popular", "jky-tile-flag--red");
        addFlag(packTiles[packTiles.length - 1], "Best Rate", "jky-tile-flag--navy");
        row.setAttribute("data-jky-flagged", "1");
      }
    }
    syncTileCount();
  }

  function preselectDefault() {
    if (window.location.search.indexOf("variant=") !== -1) return;
    var packTiles = [], tiles = document.querySelectorAll(".variant-input");
    for (var i = 0; i < tiles.length; i++) {
      if (packCount(tiles[i].getAttribute("data-value")) !== null) packTiles.push(tiles[i]);
    }
    if (packTiles.length < 3) return;
    var input = packTiles[Math.floor((packTiles.length - 1) / 2)].querySelector("input[data-variant-input]");
    if (input && !input.checked) input.click();
  }

  /* ------------------------------------------------------------- pricing */

  function selectedPlanId() {
    var checked = document.querySelector(".jky-freq__input:checked");
    return checked && checked.value ? checked.value : null;
  }

  function markSelected() {
    var rws = document.querySelectorAll(".jky-freq__row");
    for (var i = 0; i < rws.length; i++) {
      var input = rws[i].querySelector(".jky-freq__input");
      if (input && input.checked) rws[i].classList.add("is-selected");
      else rws[i].classList.remove("is-selected");
    }
  }

  /* Subscriptions are for bundles. In Individual mode the whole frequency
     block is hidden and one-time is forced, so no plan can be submitted. */
  function applyModeRules() {
    var freq = document.querySelector("[data-jky-freq]");
    var label = document.querySelector(".jky-freq-label");
    var mode = currentMode();
    var individual = /individual/i.test(mode);

    if (freq) freq.setAttribute("data-jky-mode", individual ? "individual" : "bundle");
    if (label) label.setAttribute("data-jky-mode", individual ? "individual" : "bundle");

    if (individual) {
      var one = document.querySelector('.jky-freq__row[data-plan="one"] .jky-freq__input');
      if (one && !one.checked) { one.checked = true; markSelected(); }
    }
  }

  function syncPrices() {
    var v = currentVariant();
    if (!v) return;
    var base = v.price;

    var one = document.querySelector("[data-jky-price-one]");
    if (one) one.textContent = money(base);

    var subRows = document.querySelectorAll('.jky-freq__row[data-plan="sub"]');
    for (var i = 0; i < subRows.length; i++) {
      var row = subRows[i];
      var planId = row.getAttribute("data-plan-id");
      var alloc = v.plans ? v.plans[planId] : null;
      var was = row.querySelector("[data-jky-price-was]");
      var sub = row.querySelector("[data-jky-price-sub]");
      var save = row.querySelector("[data-jky-save]");

      if (alloc) {
        row.removeAttribute("data-jky-unavailable");
        if (was) was.textContent = alloc.price < base ? money(base) : "";
        if (sub) sub.textContent = money(alloc.price);
        if (save) {
          var pct = base > 0 ? Math.round((1 - alloc.price / base) * 100) : 0;
          save.textContent = pct > 0 ? pct + "%" : money(0);
        }
      } else {
        row.setAttribute("data-jky-unavailable", "1");
        if (was) was.textContent = "";
        if (sub) sub.textContent = "—";
        if (save) save.textContent = "—";
      }
    }

    var chosen = selectedPlanId();
    if (chosen && (!v.plans || !v.plans[chosen])) {
      var oneInput = document.querySelector('.jky-freq__row[data-plan="one"] .jky-freq__input');
      if (oneInput) { oneInput.checked = true; markSelected(); }
    }

    /* Line total, not unit price. */
    var atc = document.querySelector('form[action*="/cart/add"] [name="add"]');
    if (atc) {
      var planId2 = selectedPlanId();
      var unit = base;
      if (planId2 && v.plans && v.plans[planId2]) unit = v.plans[planId2].price;
      var span = atc.querySelector(".jky-atc-price");
      if (!span) {
        span = document.createElement("span");
        span.className = "jky-atc-price";
        atc.appendChild(span);
      }
      span.textContent = money(unit * qtyValue());
    }
  }

  /* --------------------------------------------------------------- wiring */

  function refresh() {
    applyModeRules();
    syncPrices();
    syncTileCount();
  }

  function hooks() {
    document.addEventListener("click", function (e) {
      if (!e.target || !e.target.closest) return;

      if (e.target.closest(".jky-rate__row")) {
        var rev = document.querySelector(".jdgm-widget, .jky-rev");
        if (rev) rev.scrollIntoView({ behavior: "smooth" });
      }

      /* stepUp/stepDown fire no change event, so the button is watched. */
      if (e.target.closest(".jky-qty__btn")) setTimeout(syncPrices, 0);
    });

    document.addEventListener("input", function (e) {
      if (e.target && e.target.matches && e.target.matches(".jky-qty__input")) syncPrices();
    });

    document.addEventListener("change", function (e) {
      if (!e.target || !e.target.matches) return;
      if (e.target.matches(".jky-qty__input")) syncPrices();
      if (e.target.matches("[data-variant-input]") || e.target.matches('[name="id"]')) {
        /* Impulse rewrites the .disabled classes after this event. */
        refresh();
        setTimeout(refresh, 0);
        setTimeout(refresh, 120);
      }
      if (e.target.matches(".jky-freq__input")) {
        markSelected();
        syncPrices();
      }
    });
  }

  function init() {
    data = readData();
    if (!data) return;
    decorateTiles();
    preselectDefault();
    markSelected();
    refresh();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { init(); hooks(); });
  } else {
    init();
    hooks();
  }
  document.addEventListener("shopify:section:load", init);
})();
